import Select from "../../../../components/Form/Select";
import Modal from "../../../../components/Modal";
import Form from "../../../../components/Form";
import Error from "../../../../components/Form/Error";
import Image from "../../../../components/Image";
import constants from "../../../../constants";
import { Title, Subtitle, Cancel, Save, Actions } from "./styles";
import { connect, useDispatch } from "react-redux";
import { updateExpertInformation } from "../../../../store/actions/user";
import { useEffect } from "react";
import { hideModal, showModal } from "../../../../store/actions/modal";


const Label = ({ country }) => {
  return (
    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
      <Image src={country.flag} width="15px" height="15px" alt={""} />{" "}
      {country.es}
    </div>
  );
};

const Component = ({ userInformation, updateExpertInformationState }) => {
  const { loading, success, error } = updateExpertInformationState;
  const dispatch = useDispatch();

  const onSubmit = ({ data, errors, setError }) => {
    const currency = constants.countries.filter(
      (country) => country.code === data.country.value
    )[0];

    dispatch(
      updateExpertInformation({
        billing_info: { country: data.country.value },
        currency: currency?.currency?.iso,
      })
    );
  };

  useEffect(() => {
    if (
      !!userInformation &&
      !!userInformation?.expert &&
      !userInformation?.expert?.billing_info?.country
    ) {
      dispatch(showModal("select-your-country"));
    }
  }, [userInformation]);

  return (
    <Modal
      name="select-your-country"
      width="364"
      showClose={false}
      onClose={() => { }}
    >
      <Title>
        ¿En qué parte del <br />
        mundo te encuentras?
      </Title>
      <div style={{ height: 8 }} />
      <Subtitle>
        Queremos conocerte para darte la mejor experiencia.
      </Subtitle>
      <div style={{ height: 28 }} />
      <Form onSubmit={onSubmit} id="expert-country-form">
        <Select
          name="country"
          options={{
            marginBottom: 0,
            data: constants.countries
              .filter((country) => country.enabled)
              .map((country) => {
                return {
                  value: country.code,
                  label: <Label country={country} />,
                };
              }),
            textField: "es",
            valueField: "code",
          }}
          placeholder="País donde vives"
          reactSelectOptions={{ isClearable: true, isSearchable: true }}
          rules={{
            required: true,
          }}
        />

        {error && <Error>Error al actualizar el perfil.</Error>}
        <div style={{ height: 13 }} />

        <Actions>
          <Cancel
            type="button"
            options={{
              skin: "purple",
              size: "lg",
              type: "outline",
            }}
            onClick={() => dispatch(hideModal())}
          >
            Cancelar
          </Cancel>

          <Save
            isSubmmiting={loading}
            options={{
              type: "filled",
              size: "lg",
              skin: "purple",
            }}
            form="expert-country-form"
          >
            Confirmar
          </Save>
        </Actions>
      </Form>
    </Modal>
  );
};

const state = ({ userStore }) => {
  const { data: userInformation } = userStore.information;
  const { states: updateExpertInformationState } =
    userStore.updateExpertInformation;
  return {
    updateExpertInformationState,
    userInformation,
  };
};

export default connect(state)(Component);
